export default __webpack_public_path__ + "static/media/diverse03-3x.0a0bfd3e.png";